module.exports = __webpack_public_path__ + "img/logo1.271508e9.png";